import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import back_n from "../Tutorials/Image/back_n.gif";
import back_o from "../Tutorials/Image/back_o.gif";
import back_d from "../Tutorials/Image/back_d.gif";
import principle_n from "../Tutorials/Image/principle_n.gif";
import tutorials_n from "../Tutorials/Image/tutorials_n.gif";
import clue_n from "../Tutorials/Image/clue_n.gif";
import solution_n from "../Tutorials/Image/solution_n.gif";
import solution_o from "../Tutorials/Image/solution_o.gif";
import solution_d from "../Tutorials/Image/solution_d.gif";
import next_n from "../Tutorials/Image/next_n.gif";
import next_o from "../Tutorials/Image/next_o.gif";
import next_d from "../Tutorials/Image/next_d.gif";
import ok_n from "../Tutorials/Image/ok_n.gif";
import ok_o from "../Tutorials/Image/ok_o.gif";
import ok_d from "../Tutorials/Image/ok_d.gif";
import done_o from "../Tutorials/Image/done_o.gif";
import done_n from "../Tutorials/Image/done_n.gif";
import x_close_btn_n from "../Tutorials/Image/x_close_btn_n.png";
import x_close_btn_o from "../Tutorials/Image/x_close_btn_o.png";
import next_step_btn_n from "../Tutorials/Image/next_step_btn_n.png";
import next_step_btn_o from "../Tutorials/Image/next_step_btn_o.png";
import got_it_btn_n from "../Tutorials/Image/got_it_btn_n.png";
import got_it_btn_o from "../Tutorials/Image/got_it_btn_o.png";
import './Style/Question.css';
import Loading from "../../Common/Loading";
import { buildNextQuestionData, buildOptionOrder, buildShuffledQuestionsOrder, saveQuestionPerformance, QuestionPerformancePayload } from '../../services/questionApi';
import { renderRfcRfic } from './utils/rfcRficUtil';

export interface AnswerRef {
    getAnswer: () => {
        marks: number;
        noOfOptions: number;
        enteredCorrectAnswer: string;
        enteredWrongAnswer: string;
        enteredBlankAnswer: string;
        scoringMethod?: number | null;
        optOrder?: string;
    } | null;
}

interface CQnsProps {
    lessonMeta?: any;
    questionHtml: string;
    currentPage: number;
    totalPages: number;
    goToNextPage?: (e: React.MouseEvent) => void;
    showAlert: (message: string) => void;
    correctAudio: string[];
    incorrectAudio: string[];
    assetsBaseUrl?: string;
    sessionId: number | null;
    isCompleting?: boolean;
    updateSessionPoints?: (pointsEarned: number) => void;
    hwid?: number | null;
    subject?: string;
    previewMode?: string | null;
    isViewLesson?: boolean;
}

const CQns: React.ForwardRefRenderFunction<AnswerRef, CQnsProps> = (props, ref) => {
    const { lessonMeta, questionHtml, currentPage, totalPages, goToNextPage, showAlert, correctAudio, incorrectAudio, assetsBaseUrl, sessionId, isCompleting, updateSessionPoints, hwid, subject, previewMode,
        isViewLesson } = props;
    const navigate = useNavigate();
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const solnIframeRef = useRef<HTMLIFrameElement>(null);
    const prcIframeRef = useRef<HTMLIFrameElement>(null);
    const viewLesson = !!isViewLesson || new URLSearchParams(window.location.search).get('ViewLesson') === 'Y';
    const isPreview =
        viewLesson &&
        (previewMode === "ANSWERS" || previewMode === "SOLUTION" || previewMode === "RFC_RFIC");
    const revealedForPageRef = useRef<number | null>(null);

    const [backSrc, setBackSrc] = useState(back_n);
    const [nextSrc, setNextSrc] = useState(next_n);
    const [okSrc, setOkSrc] = useState(ok_n);
    const [doneSrc, setDoneSrc] = useState(done_n);
    const [solutionSrc, setSolutionSrc] = useState(solution_n);
    const [CloseBtnSrc, setCloseBtnSrc] = useState(x_close_btn_n);
    const [NextStepBtnSrc, setNextStepBtnSrc] = useState(next_step_btn_n);
    const [GotItBtnSrc, setGotItBtnSrc] = useState(got_it_btn_n);

    const [okClicked, setOkClicked] = useState(false);
    const lockAfterAnswer = okClicked && !isPreview;
    const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
    const [currentQnMeta, setCurrentQnMeta] = useState<any | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [startTime, setStartTime] = useState<Date | null>(null);

    const [showClueModal, setShowClueModal] = useState(false);
    const [clueContent,
        setClueContent
    ] = useState('');
    const [isClueLoading,
        setIsClueLoading
    ] = useState(false);
    const [noOfClues, setNoOfClues] = useState(0);
    const [currentClueNo, setCurrentClueNo] = useState(0);
    const [clueSeen, setClueSeen] = useState(false);
    const clueIframeRef = useRef<HTMLIFrameElement>(null)
    const [showPrcModal, setShowPrcModal] = useState(false);
    const [prcContent,
        setPrcContent
    ] = useState("");
    const [isPrcLoading,
        setIsPrcLoading
    ] = useState(false);
    const [prcSeen, setPrcSeen] = useState(false);
    const [showSolnModal, setShowSolnModal] = useState(false);
    const [principleList, setPrincipleList] = useState<string[]>([]);
    const [currentPrcIndex, setCurrentPrcIndex] = useState(0);

    const [isSolnLoading,
        setIsSolnLoading
    ] = useState(false);
    const [solnContent,
        setSolnContent
    ] = useState("");
    const [currentSolnNo, setCurrentSolnNo] = useState(0);
    const [revealedSolnSteps, setRevealedSolnSteps] = useState<number[]>([]);
    useEffect(() => {
        setCurrentSolnNo(0);
        setRevealedSolnSteps([]);
    }, [currentQnMeta?.QnNo]);
    const [noOfSteps, setNoOfSteps] = useState(0);
    const [solutionSeen, setSolutionSeen] = useState<string | number>('N');

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const folderParam = params.get('folder');
    const lessonName = params.get('name');
    const diccode = params.get('diccode');
    const calledFrom = params.get('calledFrom') || params.get('CalledFrom');
    const isInAssessment = window.location.href.includes('Assessment');

    const handleNextStepBtnMouseOver = () => setNextStepBtnSrc(next_step_btn_o);
    const handleNextStepBtnMouseOut = () => setNextStepBtnSrc(next_step_btn_n);
    const handleGotItBtnMouseOver = () => setGotItBtnSrc(got_it_btn_o);
    const handleGotItBtnMouseOut = () => setGotItBtnSrc(got_it_btn_n);
    const handleCloseBtnMouseOver = () => setCloseBtnSrc(x_close_btn_o);
    const handleCloseBtnMouseOut = () => setCloseBtnSrc(x_close_btn_n);
    const handleBackMouseOver = () => setBackSrc(back_o);
    const handleBackMouseOut = () => setBackSrc(back_n);
    const handleBackMouseDown = () => setBackSrc(back_d);
    const handleBackMouseUp = () => setBackSrc(back_o);
    const handleNextMouseOver = () => setNextSrc(next_o);
    const handleNextMouseOut = () => setNextSrc(next_n);
    const handleNextMouseDown = () => setNextSrc(next_d);
    const handleNextMouseUp = () => setNextSrc(next_o);
    const handleOkMouseOver = () => setOkSrc(ok_o);
    const handleOkMouseOut = () => setOkSrc(ok_n);
    const handleOkMouseDown = () => setOkSrc(ok_d);
    const handleOkMouseUp = () => setOkSrc(ok_o);
    const handleSolutionMouseOver = () => setSolutionSrc(solution_o);
    const handleSolutionMouseOut = () => setSolutionSrc(solution_n);
    const handleSolutionMouseDown = () => setSolutionSrc(solution_d);

    const handleClueClick = useCallback(async () => {
        if (!currentQnMeta || !lessonMeta) return;

        setShowClueModal(true);
        setIsClueLoading(true);
        setClueContent("");
        setCurrentClueNo(0);
        setNoOfClues(0);

        const searchParams = new URLSearchParams(window.location.search);
        const folderParam = searchParams.get('folder');
        const countryParam = params.get('country') || 'Australia';
        const varValuesParam = currentQnMeta?.VarValues || "";

        if (!folderParam) {
            showAlert("Could not determine the lesson folder.");
            setIsClueLoading(false);
            setShowClueModal(false);
            return;
        }

        const accessToken = localStorage.getItem('access_token');
        const headers: HeadersInit = { 'Content-Type': 'application/json' };
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        } else {
            console.warn("Access token not found in localStorage.");
        }

        const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

        try {
            const response = await fetch(`${apiUrl}clue/`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    folder: folderParam,
                    questionNo: currentQnMeta.QnNo,
                    country: countryParam,
                    varValues: varValuesParam,
                }),
            });

            if (!response.ok) {
                if (response.status === 404) {
                    setClueContent("<!-- No clue available -->");
                } else {
                    if (response.status === 401 || response.status === 403) {
                        showAlert("Authentication failed. Please log in again.");
                    }
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
            } else {
                const data = await response.json();
                setClueContent(data.clueHtml || "<!-- Error loading clue content -->");
                setClueSeen(true); // Mark clue as seen
            }

        } catch (error) {
            console.error("Error fetching clue:", error);
            if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403") || error.message.includes("status: 404")))) {
                showAlert("Failed to load the clue. Please try again.");
            }
            setClueContent("<!-- Error loading clue content -->");
        } finally {
            setIsClueLoading(false);
        }
    }, [currentQnMeta, lessonMeta, showAlert, params]);

    const fetchPrincipleContent = async (principleId: string, folderParam: string, countryParam: string) => {
        const accessToken = localStorage.getItem('access_token');
        const headers: HeadersInit = { 'Content-Type': 'application/json' };
        if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

        const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

        const response = await fetch(`${apiUrl}principle/`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                folder: folderParam,
                questionNo: principleId,
                country: countryParam,
            }),
        });

        if (!response.ok) throw new Error("Failed");
        return await response.json();
    };

    const handlePrcClick = useCallback(async () => {
        if (!currentQnMeta || !lessonMeta) return;

        // 1. Parse Principle Numbers
        const prcString = currentQnMeta.PrincipleNos || "";
        const prcIds = prcString.replace(/"/g, "").split(',').filter((s: string) => s.trim() !== "");

        // 2. Fallback Logic
        if (prcIds.length === 0) {
            if ((currentQnMeta.NoOfPrc || 0) > 0) {
                // If metadata says principles exist but list is empty, default to "1"
                prcIds.push("1");
            } else {
                showAlert("No principles found for this question.");
                return;
            }
        }

        setShowPrcModal(true);
        setIsPrcLoading(true);
        setPrcContent("");
        setPrincipleList(prcIds);
        setCurrentPrcIndex(0);

        const searchParams = new URLSearchParams(window.location.search);
        const folderParam = searchParams.get('folder');
        const countryParam = params.get('country') || 'Australia';

        if (!folderParam) {
            showAlert("Could not determine the lesson folder.");
            setIsPrcLoading(false);
            setShowPrcModal(false);
            return;
        }

        try {
            const data = await fetchPrincipleContent(prcIds[0], folderParam, countryParam);
            setPrcContent(data.principleHtml || "");
            setPrcSeen(true);
        } catch (error) {
            console.error("Error fetching principle:", error);
            setPrcContent("");
        } finally {
            setIsPrcLoading(false);
        }
    }, [currentQnMeta, lessonMeta, showAlert, params]);

    const handleSolnClick = useCallback(async (autoExpand = false) => {
        if (!currentQnMeta || !lessonMeta) return;

        setShowSolnModal(true);
        setIsSolnLoading(true);
        setSolnContent("");
        setNoOfSteps(0);

        const searchParams = new URLSearchParams(window.location.search);
        const folderParam = searchParams.get('folder');
        const countryParam = searchParams.get('country') || 'Australia';

        if (!folderParam) {
            showAlert("Could not determine the lesson folder.");
            setIsSolnLoading(false);
            setShowSolnModal(false);
            return;
        }

        const accessToken = localStorage.getItem('access_token');
        const headers: HeadersInit = { 'Content-Type': 'application/json' };
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        } else {
            console.warn("Access token not found in localStorage.");
        }

        const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

        try {
            const response = await fetch(`${apiUrl}solution/`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    folder: folderParam,
                    questionNo: currentQnMeta.QnNo,
                    country: countryParam,
                    autoExpand: autoExpand,
                }),
            });

            // No solution file for this question.
            if (response.status === 404) {
                setShowSolnModal(false);
                showAlert("No solution found for this question.");
                return;
            }

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    showAlert("Authentication failed. Please log in again.");
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            // 200 with an error body or empty solution.
            if (data?.error || !data?.solutionHtml) {
                setShowSolnModal(false);
                showAlert("No solution found for this question.");
                return;
            }

            setSolnContent(data.solutionHtml);
            if (solutionSeen === 'N') {
                setSolutionSeen(1);
            }

        } catch (error) {
            console.error("Error fetching solution:", error);
            if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403")))) {
                showAlert("Failed to load the solution. Please try again.");
            }
            setShowSolnModal(false);
        } finally {
            setIsSolnLoading(false);
        }
    }, [currentQnMeta, lessonMeta, showAlert, solutionSeen]);

    // Keeps the latest handleSolnClick available to the preview reveal.
    const handleSolnClickRef = useRef(handleSolnClick);
    useEffect(() => {
        handleSolnClickRef.current = handleSolnClick;
    }, [handleSolnClick]);

    const adjustSolnModalHeight = useCallback((scrollToBottom: boolean = false) => {
        setTimeout(() => {
            const iframe = solnIframeRef.current;
            if (!iframe || !iframe.contentDocument?.body) return;

            const iframeDoc = iframe.contentDocument;
            const divPCS = document.getElementById('divPCS') as HTMLElement;
            const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
            const navTable = document.getElementById('tblNavPCS') as HTMLElement;

            if (!divPCS || !titleTable || !navTable) return;

            const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
            let totalContentHeight = 0;

            stepRows.forEach(step => {
                if (step.style.display !== 'none') {
                    totalContentHeight += step.scrollHeight;
                }
            });

            const titleHeight = titleTable.offsetHeight;
            const navHeight = navTable.offsetHeight;
            const maxIframeHeight = window.innerHeight * 0.4;
            let newIframeHeight;

            if (totalContentHeight > maxIframeHeight) {
                newIframeHeight = maxIframeHeight;
                iframe.style.overflowY = 'auto';
            } else {
                newIframeHeight = totalContentHeight;
                iframe.style.overflowY = 'hidden';
            }

            newIframeHeight = Math.max(newIframeHeight, 150);
            iframe.style.height = `${newIframeHeight}px`;
            divPCS.style.height = `${titleHeight + newIframeHeight + navHeight}px`;

            if (scrollToBottom && iframe.contentWindow) {
                iframe.contentWindow.scrollTo(0, iframe.contentDocument.body.scrollHeight);
            }

        }, 50);
    }, []);

    useEffect(() => {
        setSelectedItems(new Set());
        setOkClicked(false);
        setSolutionSeen('N');
        setClueSeen(false);
        setPrcSeen(false);

        revealedForPageRef.current = null;

        if (lessonMeta?.qns) {
            setCurrentQnMeta(lessonMeta.qns[currentPage - 1]);
        }

        setStartTime(new Date());

    }, [currentPage, lessonMeta, questionHtml]);

    const injectCheckboxBridge = (html: string): string => {
        let cleaned = html
            .replace(/onmousemove="[^"]*"/gi, "")
            .replace(/<script[\s\S]*?<\/script>/gi, "")
            .replace(/(<textarea[^>]*id="KSD_W"[^>]*)\s+style="[^"]*"/gi, "$1");
        const bridge = `
            <style>
                * { background-color: transparent !important; }
                body { font-family: Arial, sans-serif; }
                #KSD_TABLE { border-collapse: separate !important; border-spacing: 0 8px !important; }
                tr[id^="KSD_TR_"] { cursor: pointer; }
                td[id^="KSD_TD_"] { cursor: pointer; padding-left: 20px; }
                td[id="KSD_TD1"], td[id="KSD_TD2"] { cursor: pointer; }
                input[id^="Chk_"], input[type="checkbox"] { display: none !important; }
                td[id="KSD_TD1"] { display: none !important; }
                td[id="KSD_TD2"] table td { background: transparent !important; }
                // td[id="KSD_TD2"] img, td[id="KSD_TD2"] .option-image { display: none !important; }
                
            </style>
            <script>
                document.addEventListener('DOMContentLoaded', function() {
                    try {
                        const optionsTable = document.querySelector("#KSD_TABLE");
                        if (!optionsTable) return;

                        let normalBgUrl = optionsTable.getAttribute('data-normal-bg');
                        let selectedBgUrl = optionsTable.getAttribute('data-selected-bg');
                        const questionInfo = document.getElementById('KSD_MW_Info');
                        const optionImageType = parseInt(questionInfo?.getAttribute('value')?.split('|')[8] || '', 10);
                        const optionImageNames = {
                            2: ['large_objective_n.png', 'large_objective_d.png'],
                            3: ['medium_objective_n.png', 'medium_objective_d.png'],
                            4: ['small_objective_n.png', 'small_objective_d.png'],
                            5: ['large_objective_shortened_n.png', 'large_objective_shortened_d.png'],
                            6: ['medium_objective_shortened_n.png', 'medium_objective_shortened_d.png'],
                            7: ['small_objective_shortened_n.png', 'small_objective_shortened_d.png']
                        };
                        const selectedImageNames = optionImageNames[optionImageType];
                        const useOptionImages = optionImageType !== 0 && !!normalBgUrl;
                        if (optionImageType === 0) {
                            normalBgUrl = null;
                            selectedBgUrl = null;
                        } else if (selectedImageNames && normalBgUrl) {
                            const replaceImageName = (url, imageName) => {
                                const parsedUrl = new URL(url, window.location.href);
                                parsedUrl.pathname = parsedUrl.pathname.replace(/[^/]+$/, imageName);
                                return parsedUrl.href;
                            };
                            normalBgUrl = replaceImageName(normalBgUrl, selectedImageNames[0]);
                            selectedBgUrl = replaceImageName(selectedBgUrl || normalBgUrl, selectedImageNames[1]);
                        }
                        const rows = Array.from(document.querySelectorAll('tr[id^="KSD_TR_"]'));

                        const getTargetCell = (row) => {
                            return row.querySelector('td[id^="KSD_TD_"]')
                                || row.querySelector('td[id="KSD_TD2"]')
                                || row.querySelector('td[id="KSD_TD1"]');
                        };

                        const applyRowState = (row, isSelected) => {
                            row.classList.toggle('selected', isSelected);

                            const checkbox = row.querySelector('input[id^="Chk_"]') || row.querySelector('input[type="checkbox"]');
                            if (checkbox) checkbox.checked = isSelected;

                            const targetCell = getTargetCell(row);
                            if (!targetCell) return;

                            if (useOptionImages) {
                                targetCell.style.backgroundImage = isSelected && selectedBgUrl
                                    ? 'url("' + selectedBgUrl + '")'
                                    : 'url("' + normalBgUrl + '")';
                                targetCell.style.backgroundRepeat = 'no-repeat';
                                targetCell.style.backgroundSize = '100% 100%';
                                targetCell.style.backgroundColor = 'transparent';
                                row.style.backgroundColor = 'transparent';
                            } else {
                                const rowIndex = rows.indexOf(row);
                                const bandColor = isSelected
                                    ? '#7A96DF'
                                    : (Math.floor(rowIndex / 2) % 2 === 0 ? '#FAF0E6' : '#F8F8F8');
                                targetCell.style.setProperty('background-image', 'none', 'important');
                                targetCell.style.setProperty('background-color', bandColor, 'important');
                            }
                        };

                        rows.forEach((row) => {
                            const targetCell = getTargetCell(row);
                            if (targetCell) {
                                if (useOptionImages) {
                                    targetCell.style.backgroundImage = 'url("' + normalBgUrl + '")';
                                    targetCell.style.backgroundRepeat = 'no-repeat';
                                    targetCell.style.backgroundSize = '100% 100%';
                                } else {
                                    // A zero image type uses the plain C-option rows.
                                    // Keep the alternating flat bands visible despite
                                    // the bridge's transparent background reset.
                                    const bandColor = Math.floor(rows.indexOf(row) / 2) % 2 === 0 ? '#FAF0E6' : '#F8F8F8';
                                    targetCell.style.setProperty('background-image', 'none', 'important');
                                    targetCell.style.setProperty('background-color', bandColor, 'important');
                                    targetCell.style.paddingLeft = '5px';
                                }
                            }
                            if (useOptionImages) {
                                row.style.backgroundColor = 'transparent';
                                if (targetCell) targetCell.style.backgroundColor = 'transparent';
                            }

                            const checkbox = row.querySelector('input[id^="Chk_"]') || row.querySelector('input[type="checkbox"]');
                            if (checkbox) {
                                checkbox.checked = checkbox.checked || false;
                            }

                            row.addEventListener('click', function() {
                                const isSelectedNow = !row.classList.contains('selected');
                                applyRowState(row, isSelectedNow);

                                const selectedIndices = Array.from(document.querySelectorAll('tr[id^="KSD_TR_"].selected'))
                                    .map(el => parseInt((el.id || '').split('_').pop() || '-1', 10))
                                    .filter(idx => idx !== -1);

                                parent.postMessage({ type: 'el-items-selected', selected: selectedIndices }, '*');
                            });
                        });
                    } catch(e) { console.error("Bridge Error:", e); }
                });
            </script>
        `;
        return cleaned.includes("</body>") ? cleaned.replace("</body>", bridge + "</body>") : cleaned + bridge;
    };

    useImperativeHandle(ref, () => ({
        getAnswer: () => {
            const iframe = iframeRef.current;
            if (!iframe?.contentDocument) return null;
            const iframeDoc = iframe.contentDocument;

            const answerKeyEl = iframeDoc.getElementById('answer-key') as HTMLInputElement;
            if (!answerKeyEl) {
                showAlert("Could not find answer key in the question.");
                return null;
            }

            const answerKey = JSON.parse(answerKeyEl.value);
            const correctAnswerCount = Object.keys(answerKey).filter((key) => answerKey[key] === true).length;

            if (selectedItems.size === 0) {
                if (correctAnswerCount > 0) {
                    showAlert(getCTypeHintMessage(correctAnswerCount));
                } else {
                    showAlert("Please select an answer.");
                }
                return null;
            }

            if (selectedItems.size < correctAnswerCount && correctAnswerCount > 0) {
                showAlert(getCTypeHintMessage(correctAnswerCount));
                return null;
            }

            const allOptions = iframeDoc.querySelectorAll('tr[id^="KSD_TR_"]');

            const enteredCorrect: string[] = [];
            const enteredWrong: string[] = [];
            const enteredBlank: string[] = [];
            let isFullyCorrect = true;

            for (let i = 0; i < allOptions.length; i++) {
                const isCorrectAnswer = answerKey[String(i)] === true;
                const wasSelected = selectedItems.has(i);

                if (isCorrectAnswer) {
                    if (wasSelected) {
                        enteredCorrect.push(String.fromCharCode(65 + i));
                    } else {
                        enteredBlank.push(String.fromCharCode(65 + i));
                        isFullyCorrect = false;
                    }
                } else {
                    if (wasSelected) {
                        enteredWrong.push(String.fromCharCode(65 + i));
                        isFullyCorrect = false;
                    }
                }
            }

            const marks = isFullyCorrect ? 1 : 0;

            return {
                marks,
                noOfOptions: allOptions.length,
                enteredCorrectAnswer: enteredCorrect.join('|'),
                enteredWrongAnswer: enteredWrong.join('|'),
                enteredBlankAnswer: enteredBlank.join('|'),
                optOrder: buildOptionOrder(iframeRef.current, 'C'),
                scoringMethod: null
            };
        }
    }));

    const getCTypeHintMessage = useCallback((correctAnswerCount: number): string => {
        if (correctAnswerCount <= 0) {
            return 'Please answer the question.';
        }

        const numberWords: Record<number, string> = {
            1: 'one',
            2: 'two',
            3: 'three',
            4: 'four',
            5: 'five',
            6: 'six',
            7: 'seven',
            8: 'eight',
            9: 'nine',
            10: 'ten'
        };

        const answerText = numberWords[correctAnswerCount] || String(correctAnswerCount);
        return correctAnswerCount === 1
            ? 'There is one correct answer'
            : `There are ${answerText} correct answers`;
    }, []);

    const playRandomSound = useCallback(async (soundFiles: string[], folder: 'Correct' | 'Incorrect') => {
        const baseUrl = assetsBaseUrl;
        if (!soundFiles || soundFiles.length === 0) return;

        const fileName = soundFiles[Math.floor(Math.random() * soundFiles.length)];
        const audioUrl = `${baseUrl}Audio/Question/${folder}/${fileName}`;

        const audio = new Audio(audioUrl);
        try {
            await audio.play();
        } catch (error) {
            console.error(`Error playing audio from ${audioUrl}:`, error);
        }
    }, [assetsBaseUrl]);

    const applyValidatedOptionTextPadding = useCallback((iframeDoc: Document) => {
        iframeDoc
            .querySelectorAll<HTMLElement>('#KSD_TABLE tr[id^="KSD_TR_"] td[id="KSD_TD2"]')
            .forEach(cell => cell.style.setProperty('padding-left', '0px', 'important'));
    }, []);


    const revealCorrectAnswers = useCallback((autoOpenSolution = false, rfcRfic = false) => {
        const iframe = iframeRef.current;
        if (!iframe?.contentDocument) return;
        const iframeDoc = iframe.contentDocument;

        const answerKeyEl = iframeDoc.getElementById("answer-key") as HTMLInputElement | null;
        if (!answerKeyEl) return;

        const answerKey = JSON.parse(answerKeyEl.value);
        const allOptions = iframeDoc.querySelectorAll('tr[id^="KSD_TR_"]');

        allOptions.forEach(option => {
            (option as HTMLElement).style.pointerEvents = "none";
        });

        const CORRECT_URL =
            "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";

        // Preview: nothing was selected by a student, so every correct
        // option simply gets the green tick.
        for (let i = 0; i < allOptions.length; i++) {
            if (answerKey[String(i)] !== true) continue;

            const feedbackCell =
                iframeDoc.getElementById(`KSD_TDANS_${i}`)
                || iframeDoc.getElementById(`TDANS_${i}`);
            if (!feedbackCell) continue;

            const feedbackElement = feedbackCell as HTMLElement;
            feedbackElement.style.display = "table-cell";
            feedbackElement.style.width = "60px !important";
            feedbackElement.style.textAlign = "center";
            feedbackElement.style.verticalAlign = "middle";
            feedbackElement.style.backgroundColor = "transparent";
            feedbackCell.innerHTML = `<img src="${CORRECT_URL}" alt="Correct"/>`;
        }

        applyValidatedOptionTextPadding(iframeDoc);

        // RFC/RFIC: correct options' reasoning first (RFC), the rest (RFIC).
        if (rfcRfic && !iframeDoc.getElementById("el-explanation-container")) {
            const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const rsnElements = Array.from(iframeDoc.querySelectorAll('[id^="TD_Rsn_"]')) as HTMLElement[];

            const items = rsnElements
                .map((el, index) => {
                    const html = el.innerHTML.trim();
                    const idSuffix = el.id.replace("TD_Rsn_", "");
                    return html
                        ? { correct: answerKey[idSuffix] === true, option: letters[index], content: html }
                        : null;
                })
                .filter((x): x is { correct: boolean; option: string; content: string } => x !== null);

            if (items.length > 0) {
                const build = (list: typeof items) =>
                    list.map(i => `<i>Option ${i.option}</i><br>${i.content}<br><br>`).join('');

                const rfcHtml = build(items.filter(i => i.correct));
                const rficHtml = build(items.filter(i => !i.correct));

                const container = iframeDoc.createElement("div");
                container.id = "el-explanation-container";
                container.innerHTML = `
                    <hr style='height:1px; background-color:#cfcfcf; border:none; margin-top:50px; margin-bottom:30px; margin-left:30px; margin-right:30px;'>
                    <p style='font-size:24px; color:#797979; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:20px'>Explanation</p>
                    <p style='font-size:24px; color:#000000; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:50px'>
                        <span style="font-weight:bold">RFC</span><br>${rfcHtml}
                        ${rficHtml ? `<span style="font-weight:bold">RFIC</span><br>${rficHtml}` : ''}
                    </p>
                `;
                iframeDoc.body.appendChild(container);
                setTimeout(() => {
                    iframeDoc.documentElement.scrollTop = iframeDoc.documentElement.scrollHeight;
                }, 100);
            }
        }

        setOkClicked(true);

        const noOfSol = lessonMeta?.qns?.[currentPage - 1]?.NoOfSol;
        if (autoOpenSolution && noOfSol && noOfSol > 0) {
            handleSolnClickRef.current(true);
        }
    }, [lessonMeta, currentPage, applyValidatedOptionTextPadding]);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (iframe && questionHtml) {
            iframe.srcdoc = injectCheckboxBridge(questionHtml);
        }
    }, [questionHtml]);

    useEffect(() => {
        if (!isPreview) return;

        const iframe = iframeRef.current;
        if (!iframe) return;

        const onLoad = () => {
            if (revealedForPageRef.current === currentPage) return;
            revealedForPageRef.current = currentPage;

            setTimeout(() => {
                revealCorrectAnswers(
                    previewMode === "SOLUTION",
                    previewMode === "RFC_RFIC"
                );
            }, 300);
        };

        iframe.addEventListener("load", onLoad);
        return () => {
            iframe.removeEventListener("load", onLoad);
        };
    }, [isPreview, previewMode, currentPage, revealCorrectAnswers]);

    useEffect(() => {
        const onMessage = (e: MessageEvent) => {
            if (e.data?.type === 'el-items-selected') {
                setSelectedItems(new Set(e.data.selected));
            }
        };
        window.addEventListener('message', onMessage);
        return () => window.removeEventListener('message', onMessage);
    }, []);

    const handleDbUpdate = useCallback((payload: QuestionPerformancePayload) => {
        // Never persist performance/points data for admin preview renders.
        if (isPreview) {
            return Promise.resolve(null as any);
        }
        return saveQuestionPerformance(payload)
            .then((data) => {
                if (isCompleting && updateSessionPoints) {
                    updateSessionPoints(data.pointsEarned || 0);
                }
                return data;
            })
            .catch((error) => {
                console.error("Save Performance Error:", error);
                throw error;
            });
    }, [isCompleting, updateSessionPoints, isPreview]);

    const handleOkClick = useCallback(async (e: React.MouseEvent<any>) => {
        e.preventDefault();
        if (okClicked || isSubmitting) return;

        const iframe = iframeRef.current;
        if (!iframe?.contentDocument) return;
        const iframeDoc = iframe.contentDocument;

        const answerKeyEl = iframeDoc.getElementById('answer-key') as HTMLInputElement;
        if (!answerKeyEl) {
            showAlert("Could not find answer key in the question.");
            return;
        }

        const answerKey = JSON.parse(answerKeyEl.value);
        const correctAnswerCount = Object.keys(answerKey).filter((key) => answerKey[key] === true).length;

        if (selectedItems.size === 0) {
            if (correctAnswerCount > 0) {
                showAlert(getCTypeHintMessage(correctAnswerCount));
            } else {
                showAlert("Please select an answer.");
            }
            return;
        }

        if (selectedItems.size < correctAnswerCount && correctAnswerCount > 0) {
            showAlert(getCTypeHintMessage(correctAnswerCount));
            return;
        }

        const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
        const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
        const chapterCode = sessionStorage.getItem('ChapterCode') || '';
        const unitCode = sessionStorage.getItem('UnitCode') || '';

        if (isPreview) {

            setSelectedItems(
                new Set(
                    Object.keys(answerKey)
                        .filter(key => answerKey[key])
                        .map(Number)
                )
            );

        }
        const allOptions = iframeDoc.querySelectorAll('tr[id^="KSD_TR_"]');

        const enteredCorrect: string[] = [];
        const enteredWrong: string[] = [];
        const enteredBlank: string[] = [];
        let isFullyCorrect = true;

        for (let i = 0; i < allOptions.length; i++) {
            const isCorrectAnswer = answerKey[String(i)] === true;
            const wasSelected =
                isPreview
                    ? answerKey[String(i)] === true
                    : selectedItems.has(i);

            if (isCorrectAnswer) {
                if (wasSelected) {
                    enteredCorrect.push(String.fromCharCode(65 + i)); // 'A', 'B', etc.
                } else {
                    enteredBlank.push(String.fromCharCode(65 + i));
                    isFullyCorrect = false;
                }
            } else {
                if (wasSelected) {
                    enteredWrong.push(String.fromCharCode(65 + i));
                    isFullyCorrect = false;
                }
            }
        }

        const marks = isFullyCorrect ? 1 : 0;
        const questionAnswerTime = startTime ? Math.floor((new Date().getTime() - startTime.getTime()) / 1000) : 0;

        const payload: QuestionPerformancePayload = {
            schoolCode: sessionStorage.getItem('SchoolCode') || '',
            familyCode: sessionStorage.getItem('FamilyCode') || '',
            login: sessionStorage.getItem('Login') || '',
            dicCode: dicCode,
            lsnTestCode: lsnTestCode,
            sessionId: sessionId || 1,
            qnNo: currentQnMeta?.QnNo,
            subNo: 0,
            qnType: currentQnMeta?.QnType,
            marks: marks,
            noOfOptions: allOptions.length,
            optOrder: buildOptionOrder(iframeRef.current, 'C'),
            enteredCorrectAnswer: enteredCorrect.join('|'),
            enteredWrongAnswer: enteredWrong.join('|'),
            enteredBlankAnswer: enteredBlank.join('|'),
            solutionSeen: (typeof solutionSeen === 'number' && solutionSeen > 0) || solutionSeen === 'Y' ? 'Y' : 'N',
            clueSeen: clueSeen,
            principleSeen: prcSeen,
            questionLoadTime: 0,
            questionAnswerTime: questionAnswerTime,
            lastQnInd: currentQnMeta?.LastQnInd || currentPage,
            nextQnData: buildNextQuestionData(lessonMeta?.qns, currentPage),
            dbgShuffledQnsOrder: buildShuffledQuestionsOrder(lessonMeta?.qns),
            allQuestionsCompleted: isCompleting ? 'True' : 'False',
            chapterCode: chapterCode,
            unitCode: unitCode,
            hwid: hwid,
            subject: subject
        };

        const isLastQuestion = currentPage === totalPages;

        if (isLastQuestion) {
            setIsSubmitting(true);
            try {
                await handleDbUpdate(payload);
            } catch (e) {
                console.error("Final submit failed", e);
                showAlert("Error saving progress. Please try again.");
                setIsSubmitting(false);
                return;
            }
            setIsSubmitting(false);
        } else {
            handleDbUpdate(payload).catch(e => console.error("Background save failed", e));
        }

        allOptions.forEach(option => {
            (option as HTMLElement).style.pointerEvents = 'none';
        });

        const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";
        const WRONG_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsWrong.GIF";
        const AnsShouldbe_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsShouldbe.GIF";
        const questionInfo = iframeDoc.getElementById('KSD_MW_Info');
        const isPlainOptionStyle = parseInt(questionInfo?.getAttribute('value')?.split('|')[8] || '', 10) === 0;

        for (let i = 0; i < allOptions.length; i++) {
            const isCorrectAnswer = answerKey[String(i)] === true;
            const wasSelected = selectedItems.has(i);
            const feedbackCell = iframeDoc.getElementById(`KSD_TDANS_${i}`)
                || iframeDoc.getElementById(`TDANS_${i}`);

            if (feedbackCell) {
                const feedbackElement = feedbackCell as HTMLElement;
                feedbackElement.style.display = "table-cell";
                // feedbackElement.style.width = "32px";
                feedbackElement.style.width = "60px";
                feedbackElement.style.textAlign = "center";
                feedbackElement.style.verticalAlign = "middle";
                feedbackElement.style.backgroundColor = "transparent";


                if (wasSelected && isCorrectAnswer) {
                    feedbackCell.innerHTML = `<img src="${CORRECT_URL}" alt="Correct"/>`;
                } else if (wasSelected && !isCorrectAnswer) {
                    feedbackCell.innerHTML = `<img src="${WRONG_URL}" alt="Incorrect"/>`;
                } else if (!wasSelected && isCorrectAnswer) {
                    feedbackCell.innerHTML = `<img src="${AnsShouldbe_URL}" alt="Should be selected"/>`;
                }
            }

            if (isPlainOptionStyle) {
                const row = allOptions[i] as HTMLElement;
                const optionColor = isCorrectAnswer
                    ? (wasSelected ? '#7A96DF' : '#FAF0E6')
                    : (wasSelected ? '#7A96DF' : '#F8F8F8');
                const optionCell = row.querySelector<HTMLElement>('td[id="KSD_TD2"]')
                    || row.querySelector<HTMLElement>('td[id^="KSD_TD_"]');
                if (optionCell) {
                    // The API puts its option artwork directly on KSD_TD2.
                    // Override the shorthand so that image cannot cover feedback color.
                    optionCell.style.setProperty('background', optionColor, 'important');
                    optionCell.querySelectorAll<HTMLElement>('td:not([id^="KSD_TDANS_"])').forEach(cell => {
                        cell.style.setProperty('background', optionColor, 'important');
                    });
                }
            }
        }

        if (isFullyCorrect) {
            playRandomSound(correctAudio, 'Correct');
        } else {
            playRandomSound(incorrectAudio, 'Incorrect');
            if (currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0) {
                handleSolnClick(true);
            }
        }

        applyValidatedOptionTextPadding(iframeDoc);
        setOkClicked(true);
    }, [selectedItems, okClicked, showAlert, handleSolnClick, correctAudio, incorrectAudio, playRandomSound, startTime, lessonMeta, currentQnMeta, currentPage, totalPages, sessionId, updateSessionPoints, handleDbUpdate, isCompleting, hwid, subject, clueSeen, prcSeen, solutionSeen, applyValidatedOptionTextPadding]);

    const handleBack = () => {
        const calledFrom = params.get("calledFrom") || params.get("CalledFrom");
        if (calledFrom) {
            const redirectPath = decodeURIComponent(calledFrom);
            window.location.href = redirectPath;
        }
        else if (window.history.length > 1) {
            window.history.back();
        }
    };

    return (
        <>
            {!isInAssessment && (
                <tr id="trQnButtons">
                    <td className="QnPanelT">
                        <table id="tabQnNav" className="QnPanel2T" style={{ height: "50px" }}>
                            <tbody>
                                <tr id="trQnOK" className="trQnOKT">
                                    <td id="QnPanelIdT" className="QnPanel">&nbsp;</td>
                                    <td id="QnPanelId2T" className="QnPanel">
                                        <div
                                            onClick={!lockAfterAnswer ? handleBack : undefined}
                                            style={{
                                                display: lockAfterAnswer ? 'none' : 'block',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <div id="imgbtnBack" className="imgbtnBackT">
                                                <img
                                                    src={backSrc}
                                                    alt="Back"
                                                    onMouseOver={handleBackMouseOver}
                                                    onMouseOut={handleBackMouseOut}
                                                    onMouseDown={handleBackMouseDown}
                                                    onMouseUp={handleBackMouseUp}
                                                    className="imgbtnBack2T"
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td id="QnPanelId3T" className="QnPanel">
                                        <input
                                            type="image"
                                            id="imgPrc"
                                            src={principle_n}
                                            className="imgPrcT"
                                            alt="Principle"
                                            style={{
                                                display:
                                                    !lockAfterAnswer &&
                                                        currentQnMeta?.NoOfPrc &&
                                                        currentQnMeta.NoOfPrc > 0
                                                        ? 'inline-block'
                                                        : 'none'
                                            }}
                                            onClick={(e) => { e.preventDefault(); handlePrcClick(); }}
                                        />
                                    </td>
                                    <td id="QnPanelId4T" className="QnPanel">
                                        <input
                                            type="image"
                                            id="imgClue"
                                            src={clue_n}
                                            className="imgClueT"
                                            alt="Clue"
                                            style={{
                                                display:
                                                    !lockAfterAnswer &&
                                                        Number(currentQnMeta?.NoOfClues || 0) > 0
                                                        ? 'inline-block'
                                                        : 'none'
                                            }}
                                            onClick={(e) => { e.preventDefault(); handleClueClick(); }}
                                        />
                                    </td>
                                    <td id="QnPanelId5T" className="QnPanel">
                                        <input
                                            type="image" id="imgSoln" src={solutionSrc} className="imgSolnT" alt="Solution"
                                            style={{ display: currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0 ? 'inline-block' : 'none' }}
                                            onClick={(e) => { e.preventDefault(); handleSolnClick(false); }}
                                            onMouseOver={handleSolutionMouseOver}
                                            onMouseOut={handleSolutionMouseOut}
                                            onMouseDown={handleSolutionMouseDown}
                                        />
                                    </td>
                                    <td id="QnPanelId5T" className="QnPanel">
                                        <a
                                            href={`/STUDENT/Tutorials/Tutorial?id=${folderParam}&name=${encodeURIComponent(lessonName ?? '')}&folder=${encodeURIComponent(diccode ?? '')}&calledFrom=${encodeURIComponent(calledFrom ?? '')}&sessionId=${sessionId}&currentPage=${currentPage}`}
                                            id="imgbtnTut"
                                            className="imgbtnTutT"
                                            style={{
                                                display: lockAfterAnswer ? 'none' : 'inline-block'
                                            }}
                                        >
                                            <img src={tutorials_n} alt="Tutorial" id="imgbtnTut2T" />
                                        </a>
                                    </td>
                                    <td id="QnPanelId6T" className="QnPanel">
                                        {isSubmitting ? (
                                            <Loading />
                                        ) : (
                                            okClicked ? (
                                                currentPage === totalPages ? (
                                                    <img
                                                        src={doneSrc}
                                                        alt="Done"
                                                        style={{ verticalAlign: 'middle', cursor: 'pointer' }}
                                                        onClick={() => {

                                                            // View Lesson Preview
                                                            if (viewLesson) {

                                                                const calledFrom = params.get("CalledFrom") || params.get("calledFrom");

                                                                if (calledFrom) {
                                                                    window.location.href = decodeURIComponent(calledFrom);
                                                                } else {
                                                                    window.history.back();
                                                                }

                                                                return;
                                                            }

                                                            // Normal student flow (UNCHANGED)
                                                            const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
                                                            const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
                                                            const calledFrom = params.get("calledFrom") || "";

                                                            navigate(
                                                                `/STUDENT/Tutorials/Result?DicCode=${dicCode}&LsnTestCode=${lsnTestCode}&SessionID=${sessionId}&source=lesson&complete=1` +
                                                                (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : "")
                                                            );
                                                        }}
                                                        onMouseOver={() => setDoneSrc(done_o)}
                                                        onMouseOut={() => setDoneSrc(done_n)}
                                                    />
                                                ) : (
                                                    <img src={nextSrc} alt="Next" onClick={goToNextPage} onMouseOver={handleNextMouseOver} onMouseOut={handleNextMouseOut}
                                                        onMouseDown={handleNextMouseDown} onMouseUp={handleNextMouseUp} style={{ display: 'inline-block', cursor: 'pointer', marginTop: '3px' }} />
                                                )
                                            ) : (
                                                <div onClick={handleOkClick} onMouseOver={handleOkMouseOver} onMouseOut={handleOkMouseOut}
                                                    onMouseDown={handleOkMouseDown} onMouseUp={handleOkMouseUp} style={{ display: 'inline-block', cursor: 'pointer' }}>
                                                    <img src={okSrc} alt="OK" style={{ marginTop: '3px' }} />
                                                </div>
                                            )
                                        )}
                                    </td>
                                    <td id="QnPanelId7" className="QnPanel">&nbsp;</td>
                                </tr>
                                <tr id="trQnNext" className="trQnNextT">
                                    <td id="tdBN1" className="QnPanel">&nbsp;</td>
                                    <td id="tdAnsMsg" className="QnPanel">&nbsp;</td>
                                    <td id="tdShowCA" className="QnPanel">&nbsp;</td>
                                    <td id="tdAnsSoln" className="QnPanel">
                                        <img id="imgSolnAfterAnswering" src={solutionSrc} alt="Solution"
                                            onClick={(e) => { e.preventDefault(); handleSolnClick(); }}
                                            onMouseOver={handleSolutionMouseOver}
                                            onMouseOut={handleSolutionMouseOut} onMouseDown={handleSolutionMouseDown} />
                                    </td>
                                    <td id="tdQnNext" className="QnPanel">
                                        {okClicked ? (
                                            <input type="image" id="imgNextQuestion" src={nextSrc} alt="Next" onClick={goToNextPage}
                                                onMouseOver={handleNextMouseOver} onMouseOut={handleNextMouseOut} onMouseDown={handleNextMouseDown}
                                                onMouseUp={handleNextMouseUp} style={{ display: okClicked ? 'inline-block' : 'none' }} />
                                        ) : (
                                            <img id="imgOK" src={okSrc} alt="OK" onClick={handleOkClick} onMouseOver={handleOkMouseOver}
                                                onMouseOut={handleOkMouseOut} onMouseDown={handleOkMouseDown} onMouseUp={handleOkMouseUp} className="imgOKT" style={{ display: okClicked ? 'none' : 'inline-block' }} />
                                        )}
                                    </td>
                                    <td id="tdBN" className="QnPanel">&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}

            <tr id="triFrame">
                <td id="tdFrameQnT" style={{ padding: 0, height: '100%' }}>
                    <div id="divFrameQn" style={{ height: 'calc(95vh - 50px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
                        {questionHtml ? (
                            <iframe
                                id="iFrameQn"
                                ref={iframeRef}
                                frameBorder={0}
                                scrolling="yes"
                                className="CssiFrm"
                                style={{
                                    flex: '1 1 0',
                                    width: '100%',
                                    height: '100%',
                                    minHeight: 0,
                                    border: 'none',
                                    overflow: 'auto'
                                }}
                                title="Question Page"
                            />
                        ) : <Loading />}
                    </div>
                </td>
            </tr>

            {showClueModal && (
                <>
                    {!showSolnModal && <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowClueModal(false)}></div>}
                    <div id="divClue" style={{ display: 'block' }}>
                        <table id="tblTitleClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ height: "50px", fontSize: "15px" }}>
                            <tbody>
                                <tr>
                                    <td id="tdClueTitle1" align="left">Clue</td>
                                    <td id="tdClueClose" align="right" valign="top">
                                        <img
                                            id="imgClueClose"
                                            src={CloseBtnSrc}
                                            alt="Close"
                                            onClick={() => setShowClueModal(false)}
                                            onMouseOver={handleCloseBtnMouseOver}
                                            onMouseOut={handleCloseBtnMouseOut}
                                            style={{ cursor: 'pointer', padding: '5px' }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div id="divFrameClue">
                            {isClueLoading ? <Loading /> : (
                                <iframe
                                    id="iFrameClue"
                                    ref={clueIframeRef}
                                    title="Clue"
                                    srcDoc={clueContent}
                                    style={{ width: '100%', border: 'none', minHeight: '80px' }}
                                    onLoad={() => {
                                        // console.log("Clue iframe onLoad event fired.");
                                        const iframe = clueIframeRef.current;
                                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) { return; }
                                        try {
                                            const divShows = iframe.contentDocument.querySelectorAll("[id^='divShow']");
                                            divShows.forEach(div => {
                                                (div as HTMLElement).style.padding = "20px";
                                            });
                                            const cluesInput = iframe.contentDocument.getElementById('NoOfClues') as HTMLInputElement;
                                            const totalClues = parseInt(cluesInput?.value || '0', 10);
                                            setNoOfClues(totalClues);
                                            const clueDivs = iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]');
                                            clueDivs.forEach((div, index) => {
                                                div.style.display = index === 0 ? 'block' : 'none';
                                            });
                                            const firstClueDiv = iframe.contentDocument.getElementById('divShow1');
                                            if (firstClueDiv) {
                                                const newHeight = firstClueDiv.scrollHeight;
                                                iframe.style.height = `${Math.min(newHeight, 300)}px`;
                                            } else if (totalClues === 0) {
                                                iframe.style.height = '50px';
                                            }
                                        } catch (e) { console.error("Error inside clue iframe onLoad:", e); }
                                    }}
                                />
                            )}
                        </div>
                        <table id="tblNavClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '33%' }}>&nbsp;</td>
                                    <td style={{ width: '34%' }}>&nbsp;</td>
                                    <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                                        {!isClueLoading && noOfClues > 1 && currentClueNo < noOfClues - 1 && (
                                            <img
                                                id="btnClueNext"
                                                src={NextStepBtnSrc}
                                                alt="Next Clue"
                                                onClick={() => {
                                                    const nextClue = currentClueNo + 1;
                                                    const iframe = clueIframeRef.current;
                                                    if (iframe?.contentDocument) {
                                                        iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]').forEach((div, index) => {
                                                            div.style.display = index === nextClue ? 'block' : 'none';
                                                        });
                                                        setCurrentClueNo(nextClue);
                                                        const nextClueDiv = iframe.contentDocument.getElementById(`divShow${nextClue + 1}`);
                                                        if (nextClueDiv) {
                                                            const newHeight = nextClueDiv.scrollHeight + 20;
                                                            iframe.style.height = `${Math.min(newHeight, 300)}px`;
                                                        }
                                                    }
                                                }}
                                                onMouseOver={handleNextStepBtnMouseOver}
                                                onMouseOut={handleNextStepBtnMouseOut}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        )}
                                        {!isClueLoading && (noOfClues <= 1 || currentClueNo === noOfClues - 1) && (
                                            <img
                                                id="btnClueGotIt"
                                                src={GotItBtnSrc}
                                                alt="Got It"
                                                onClick={() => setShowClueModal(false)}
                                                onMouseOver={handleGotItBtnMouseOver}
                                                onMouseOut={handleGotItBtnMouseOut}
                                                style={{ cursor: 'pointer', display: isClueLoading ? 'none' : 'inline-block' }}
                                            />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {showPrcModal && (
                <>
                    <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowPrcModal(false)}></div>

                    <div id="divPCS" style={{ display: 'block' }} className="principle">

                        {/* Header */}
                        <table id="tblTitlePCS" className="principle" cellSpacing="0" cellPadding="0" width="100%">
                            <tbody>
                                <tr>
                                    <td id="tdPCSTitle1" style={{ paddingLeft: '15px', color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
                                        Principle {principleList.length > 1 ? ` ${currentPrcIndex + 1} of ${principleList.length}` : ''}
                                    </td>
                                    <td id="tdPCSClose" align="right" valign="top">
                                        <img
                                            id="imgPCSClose"
                                            src={CloseBtnSrc}
                                            alt="Close"
                                            onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                                            onMouseOver={handleCloseBtnMouseOver}
                                            onMouseOut={handleCloseBtnMouseOut}
                                            style={{ cursor: 'pointer', padding: '5px', width: '40px', height: '40px', marginRight: '30px' }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Body */}
                        <div id="divFramePCS">
                            {isPrcLoading ? <Loading /> : (
                                <iframe
                                    id="iFramePrc"
                                    ref={prcIframeRef}
                                    title="Prc"
                                    srcDoc={prcContent}
                                    style={{ width: '100%', border: 'none', overflow: 'hidden', display: 'block' }} // 2. Set overflow hidden initially
                                    onLoad={() => {
                                        const iframe = prcIframeRef.current;
                                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;

                                        setTimeout(() => {
                                            if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                                            const contentHeight = iframe.contentDocument.body.scrollHeight + 20;

                                            const divPCS = document.getElementById('divPCS') as HTMLElement;
                                            const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                            const navTable = document.getElementById('tblNavPCS') as HTMLElement;
                                            if (divPCS && titleTable && navTable) {
                                                const maxModalHeight = window.innerHeight * 0.8;
                                                const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;
                                                if (contentHeight > maxIframeHeight) {

                                                    iframe.style.height = `${maxIframeHeight}px`;
                                                    iframe.style.overflowY = 'auto';
                                                } else {

                                                    iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                                                    iframe.style.overflowY = 'hidden';
                                                }
                                            } else {
                                                iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                                            }
                                        }, 50);
                                    }}
                                />
                            )}
                        </div>

                        {/* Footer / Navigation */}
                        <table id="tblNavPCS" className="principle" cellSpacing="0" cellPadding="0" width="100%" style={{ height: '50px' }}>
                            <tbody>
                                <tr style={{ backgroundColor: '#F2F2F2' }}>
                                    {/* Previous Button */}
                                    <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                                        {currentPrcIndex > 0 && (
                                            <input
                                                type='button'
                                                value='PREVIOUS'
                                                onClick={() => {
                                                    const prevIndex = currentPrcIndex - 1;
                                                    setCurrentPrcIndex(prevIndex);
                                                    const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                                                    const countryParam = params.get('country') || 'Australia';
                                                    fetchPrincipleContent(principleList[prevIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                                                }}
                                                style={{
                                                    fontWeight: 'bold',
                                                    color: 'White',
                                                    fontSize: '12pt',
                                                    borderStyle: 'none',
                                                    backgroundColor: 'maroon',
                                                    cursor: 'pointer',
                                                    padding: '5px 10px'
                                                }}
                                            />
                                        )}
                                    </td>

                                    <td style={{ width: '34%' }}>&nbsp;</td>

                                    {/* Next / Got It Button */}
                                    <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                                        {currentPrcIndex < principleList.length - 1 ? (
                                            <img
                                                src={NextStepBtnSrc}
                                                alt="Next"
                                                onClick={() => {
                                                    const nextIndex = currentPrcIndex + 1;
                                                    setCurrentPrcIndex(nextIndex);
                                                    const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                                                    const countryParam = params.get('country') || 'Australia';
                                                    fetchPrincipleContent(principleList[nextIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                                                }}
                                                onMouseOver={handleNextStepBtnMouseOver}
                                                onMouseOut={handleNextStepBtnMouseOut}
                                                style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                                            />
                                        ) : (
                                            <img
                                                src={GotItBtnSrc}
                                                id="imgGotIt"
                                                alt="Got It"
                                                onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                                                onMouseOver={handleGotItBtnMouseOver}
                                                onMouseOut={handleGotItBtnMouseOut}
                                                style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                                            />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {showSolnModal && (
                <>
                    <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => {
                        setShowSolnModal(false);
                    }}></div>

                    <div id="divPCS" style={{ display: 'block', position: 'fixed', bottom: '0', width: '100%', zIndex: 10000 }}>
                        <table id="tblTitlePCS" className="solution" cellSpacing="0" cellPadding="0" width="100%">
                            <tbody>
                                <tr>
                                    <td id="tdPCSTitle1">Step by step solution</td>
                                    <td id="tdPCSClose" align="right" valign="top">
                                        <button
                                            type="button"
                                            aria-label="Close solution"
                                            onClick={() => setShowSolnModal(false)}
                                            style={{ width: '30px', height: '30px', margin: '5px 15px 5px 0', padding: 0, border: 0, borderRadius: 0, backgroundColor: '#ff6500', color: '#fff', fontSize: '18px', lineHeight: '30px', textAlign: 'center', cursor: 'pointer' }}
                                        >
                                            ×
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div id="divFramePCS">
                            {isSolnLoading ? <Loading /> : (
                                <iframe
                                    id="iFrameSolution"
                                    ref={solnIframeRef}
                                    title="Solution"
                                    srcDoc={solnContent}
                                    style={{ width: '100%', border: 'none', minHeight: '50px' }}
                                    onLoad={() => {
                                        const iframe = solnIframeRef.current;
                                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) {
                                            console.error("Iframe document or window not ready in onLoad.");
                                            return;
                                        }

                                        try {
                                            const iframeDoc = iframe.contentDocument;
                                            const stepsInput = iframeDoc.getElementById('NoOfSteps') as HTMLInputElement;
                                            const totalSteps = parseInt(stepsInput?.value || '0', 10);
                                            setNoOfSteps(totalSteps);
                                            const isAutoExpanded = iframeDoc.getElementById('IsAutoExpanded');

                                            const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');

                                            stepRows.forEach((step, index) => {
                                                if (index <= currentSolnNo || isAutoExpanded) {
                                                    step.style.display = 'table-row';
                                                } else {
                                                    step.style.display = 'none';
                                                }
                                            });

                                            if (totalSteps === 0) {
                                                iframe.style.height = '50px';
                                            }

                                            setTimeout(() => {
                                                if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                                                const contentHeight = iframe.contentDocument.body.scrollHeight + 5;

                                                const divPCS = document.getElementById('divPCS') as HTMLElement;
                                                const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                                const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                                                if (divPCS && titleTable && navTable) {
                                                    const maxModalHeight = window.innerHeight * 0.45;
                                                    const currentModalHeight = divPCS.offsetHeight;
                                                    const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;

                                                    if (contentHeight > maxIframeHeight) {
                                                        iframe.style.height = `${maxIframeHeight}px`;
                                                        iframe.style.overflowY = 'auto';
                                                    } else {
                                                        iframe.style.height = `${Math.max(contentHeight, 50)}px`;
                                                        iframe.style.overflowY = 'hidden';
                                                    }
                                                }

                                                if (isAutoExpanded) {
                                                    setCurrentSolnNo(totalSteps - 1);
                                                    if (solutionSeen !== 'Y') {
                                                        setSolutionSeen('Y');
                                                    }
                                                    iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);
                                                } else {
                                                    iframe.contentWindow?.scrollTo(0, 0);
                                                }
                                            }, 50);

                                            iframeDoc.querySelectorAll<HTMLImageElement>('img[id^="KsdImg"]').forEach(img => {
                                                const index = img.id.substring(6);
                                                const ksdDiv = iframeDoc.getElementById(`KsdDiv${index}`);
                                                const content = ksdDiv?.getAttribute('data-ksd-content');
                                                const wasPreviouslyRevealed = revealedSolnSteps.includes(Number(index));
                                                const parentTd = img.closest('td');

                                                if (content && parentTd && wasPreviouslyRevealed) {
                                                    parentTd.innerHTML = content;
                                                    img.setAttribute('alt', '2');
                                                    return;
                                                }

                                                img.onclick = () => {
                                                    if (content && parentTd && img.getAttribute('alt') === '1') {
                                                        parentTd.innerHTML = content;
                                                        img.setAttribute('alt', '2');
                                                        setRevealedSolnSteps(previous => previous.includes(Number(index)) ? previous : [...previous, Number(index)]);
                                                    }
                                                };
                                            });

                                        } catch (e) {
                                            console.error("Error inside solution iframe onLoad:", e);
                                        }
                                    }}
                                />
                            )}
                        </div>

                        <table id="tblNavPCS" className="solution" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
                            <tbody>
                                <tr>
                                    <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                                    </td>

                                    <td style={{ width: '34%' }}>
                                        &nbsp;
                                    </td>

                                    <td align="right" style={{ width: '33%', paddingRight: '15px' }}>

                                        {!isSolnLoading && noOfSteps > 0 && currentSolnNo < noOfSteps - 1 && (
                                            <img
                                                id="btnPCSNext"
                                                src={NextStepBtnSrc}
                                                alt="Next Step"
                                                onClick={() => {
                                                    const nextStep = currentSolnNo + 1;
                                                    const iframe = solnIframeRef.current;

                                                    if (iframe?.contentDocument?.body) {
                                                        const iframeDoc = iframe.contentDocument;

                                                        const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                                                        if (nextStep >= stepRows.length) return;

                                                        const nextStepElement = stepRows[nextStep];
                                                        nextStepElement.style.display = 'table-row';

                                                        setTimeout(() => {
                                                            if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                                                            const divPCS = document.getElementById('divPCS') as HTMLElement;
                                                            const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                                            const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                                                            if (!divPCS || !titleTable || !navTable) return;

                                                            const maxModalHeight = window.innerHeight * 0.45;
                                                            const chromeHeight = titleTable.offsetHeight + navTable.offsetHeight;
                                                            const maxIframeHeight = maxModalHeight - chromeHeight;

                                                            const fullContentHeight = iframe.contentDocument.body.scrollHeight + 5;

                                                            let newHeight = fullContentHeight;
                                                            let showScroll = false;

                                                            if (fullContentHeight > maxIframeHeight) {
                                                                newHeight = maxIframeHeight;
                                                                showScroll = true;
                                                            }

                                                            iframe.style.height = `${newHeight}px`;
                                                            iframe.style.overflowY = showScroll ? 'auto' : 'hidden';

                                                            if (iframe.contentWindow) {
                                                                iframe.contentWindow.scrollTo(0, iframe.contentDocument.body.scrollHeight);
                                                            }
                                                        }, 50);

                                                        setCurrentSolnNo(nextStep);
                                                        if (solutionSeen !== 'Y') {
                                                            setSolutionSeen(nextStep + 1);
                                                        }
                                                    }
                                                }}
                                                onMouseOver={handleNextStepBtnMouseOver}
                                                onMouseOut={handleNextStepBtnMouseOut}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        )}

                                        {!isSolnLoading && (noOfSteps === 0 || currentSolnNo === noOfSteps - 1) && (
                                            <img
                                                id="btnPCSClose"
                                                src={GotItBtnSrc}
                                                alt="Got It"
                                                onClick={() => {
                                                    setShowSolnModal(false);
                                                    setSolutionSeen('Y');
                                                }}
                                                onMouseOver={handleGotItBtnMouseOver}
                                                onMouseOut={handleGotItBtnMouseOut}
                                                style={{ cursor: 'pointer', display: isSolnLoading ? 'none' : 'inline-block' }}
                                            />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </>
    );
};

export default forwardRef(CQns);
